import { render, staticRenderFns } from "./FavoriteBbsItem.vue?vue&type=template&id=2f409f7b&"
import script from "./FavoriteBbsItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteBbsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f409f7b', component.options)
    } else {
      api.reload('2f409f7b', component.options)
    }
    module.hot.accept("./FavoriteBbsItem.vue?vue&type=template&id=2f409f7b&", function () {
      api.rerender('2f409f7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/FavoriteBbsItem.vue"
export default component.exports